<template>
    <customModal :containerxxl=true :bodyxl=true :footerShow=true @closeModal="closeSDVModal">
       <template #title>
    <h4 class="my-0">
        {{
            modalType === 'viewSDV'
                ? 'eCRF Data'
                : $t("navigations.verify source data")
        }}
    </h4>
</template>
        <template #body>
            <!-- Data Table -->
            <div class="row">
                <div class="col-12">
                    <div class="table-container">
                        <!-- <div class="d-flex justify-content-between align-items-center px-3 py-1 bg-light">
                            <h4 class="card-title mb-1 text-primary">Verification Records</h4>
                        </div> -->

                        <div class="table-responsive">
                            <table class="table table-striped sdv-table mb-2" style="width:100%;">
                                <thead>
                                    <tr>
                                        <th 
                                            v-if="modalType === 'doSDV'"
                                            style="width:2%;">
                                            <input 
                                                type="checkbox" 
                                                v-model="selectAllChecked"
                                                :disabled="!hasPendingItems"
                                                @change="SelectAll()" />
                                        </th>
                                        <th style="width:7%;">Site Code</th>
                                        <th style="width:7%;">Subject ID</th>
                                        <th style="width:7%;">Visit Name</th>
                                        <th style="width:25%;">eCRF</th>
                                        <th style="width:14%;">Field Label</th>
                                        <th style="width:15%;">Value</th>
                                        <th style="width:8%;">SDV Status</th>
                                        <th style="width:10%;">SDV Outcome</th>
                                        <th 
                                            v-if="modalType === 'doSDV'"
                                            class="text-center"
                                            style="width:10%;"
                                            >Actions
                                        </th>
                                        <th v-if="modalType === 'doSDV'"
                                            class="text-center"
                                            style="width:10%;"
                                            >Query</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in sdvDataRef" :key="row.DataRefID">
                                        <td 
                                            v-if="modalType === 'doSDV'"
                                            class="text-center">
                                            <input 
                                                type="checkbox" 
                                                v-model="dataIndex[index]" 
                                                :disabled="row.SDVStatus  == 'Completed' || row.SDVStatus  == 'Discrepant'"
                                                @click="selectRow(row,index)" /> 
                                        </td>
                                        <td>{{ row.SiteCode }}</td>
                                        <td>{{ row.SubjectNo }}</td>
                                        <td>{{ row.VisitFormName }}</td>
                                        <td>{{ row.FormName }}</td>
                                        <td>{{ row.FieldLabel }}</td>
                                        <td>{{ arrayToCommaString(row.FieldValue)}}</td>
                                        <td>{{ row.SDVStatus }}</td>
                                        <td>{{ row.Outcome }}</td>
                                        <td v-if="modalType === 'doSDV'" class="text-center">
                                            <button 
                                                v-if="row.SDVStatus == 'Pending'"
                                                class="btn btn-sm btn-outline-secondary action-btn me-2"
                                                @click="discrepantRow(row, 'Discrepancy')"
                                            >
                                                Discrepancy
                                            </button>
                                             <span 
                                                v-if="row.SDVStatus == 'Discrepant'"
                                                class="badge badge-warning mr-2"> Discrepant
                                            </span>
                                            <span 
                                                v-if="row.SDVStatus == 'Completed'"
                                                class="badge badge-primary mr-2"> Verified
                                            </span>

                                            <button 
                                                 v-if="row.SDVStatus == 'Pending'"
                                                class="btn btn-sm btn-primary action-btn"
                                                @click="verifyRow(row, 'Verified')">
                                                <i class="fa fa-check me-1"></i> Verify
                                            </button>
                                        </td>
                                        <td v-if="modalType === 'doSDV'" class="text-center">
                                            <i @click="Openquerypopup(row)"
                                                class="fa fa-question-circle edit-delete">
                                            </i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div v-if="modalType === 'doSDV' && hasPendingItems">
                <button 
                    class="btn btn-success btn-sm  float-right mb-2 mr-2"
                    @click="verifySelected()">
                    <i class="fa fa-check me-1"></i> Verify All Checked
                </button>
                 <button 
                    class="btn btn-primary btn-sm  float-right mb-2 mr-2"
                    @click="discrepantSelected('Discrepancy')">
                    <i class="fa fa-check me-1"></i> Discrepancy
                </button>
            </div>
        </template>
    </customModal>
    <discrepancyModal
        v-if="showDiscrepancyModal"
        :sdvPayload="sdvPayload"
        :fromTab ="fromTab"
        @closeModal="closeDiscrepancy()"
    />
    
    <ListSdvQueryModal
        v-if="showQueryModal"
        :signalid = "selectedId"
        :fieldName="selectedFieldName"
        @closeModal="closeQueryModal"
    />
</template>

<script src="./SDV_VerificationModal.js"></script>

<style scoped>
.sdv-table th,
.sdv-table td {
    padding: 3px 6px;
}
.btn-filter{
    padding:1px 6px;
}
.btn-view {
    background: #0d6efd;
    color: rgb(255, 255, 255);
    padding: 0px 10px;
    font-size: 12px;
}

.btn-verify {
    background: #6c757d;
    color: white;
    padding: 0px 10px;
    font-size: 11px;
}

.action-btn {
    padding: 1px 10px;
    font-size: 11px;
}

.pagination-info {
    font-size: 11px;
    color: var(--secondary);
}

.status-badge {
    padding: 1px 10px;
    border-radius: 100px;
    font-size: 11px;
    font-weight: 500;
}

.status-verified {
    background:  #137333;
    color:#e6f4ea;
}
.status-discrepant{
    background: #b06000;
    color: #fef7e0;
}

.status-pending {
    background: #fef7e0;
    color: #b06000;
}

.filter-section {
    background: white;
    border:solid 1px #ebebeb;
    border-radius: 10px;
    padding: 2px 15px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
}

.table-container {
    background: white;
    border-radius: 10px;
    border:solid 1px #ebebeb;
    overflow: hidden;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
}
</style>
